import { YoutubeLogo, TiktokLogo, InstagramLogo, TwitterLogo, FacebookLogo, Broadcast } from "@phosphor-icons/react";

const ICONS = {
  youtube: { icon: YoutubeLogo, color: "text-red-600", label: "YouTube" },
  tiktok: { icon: TiktokLogo, color: "text-zinc-950", label: "TikTok" },
  instagram: { icon: InstagramLogo, color: "text-pink-600", label: "Instagram" },
  twitter: { icon: TwitterLogo, color: "text-zinc-900", label: "X" },
  facebook: { icon: FacebookLogo, color: "text-blue-600", label: "Facebook" },
};

export default function PlatformBadge({ platform, size = "sm" }) {
  const meta = ICONS[platform] || { icon: Broadcast, color: "text-zinc-600", label: "Video" };
  const Icon = meta.icon;
  const iconCls = size === "lg" ? "w-4 h-4" : "w-3.5 h-3.5";
  const textCls = size === "lg" ? "text-[11px]" : "text-[10px]";

  return (
    <span
      data-testid={`platform-badge-${platform || "unknown"}`}
      className={`inline-flex items-center gap-1.5 font-mono-plex ${textCls} font-semibold border border-zinc-300 bg-white text-zinc-900 px-2 py-0.5`}
    >
      <Icon weight="fill" className={`${iconCls} ${meta.color}`} />
      {meta.label}
    </span>
  );
}
